<template>
  <a-modal
    v-model:visible="modalConfig.visible"
    :title="modalConfig.title"
    @ok="handleOk"
    @cancel="handleCancel"
  >
    <a-form :model="formState">
      <a-form-item>
        <a-input
          v-model:value="formState.structureName"
          aria-placeholder="请输入组织架构名称"
        ></a-input>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<script>
import { defineComponent, reactive } from "vue";
import { saveStructure } from "@/request/view/personal";
import { Toast } from "@/utils";

export default defineComponent({
  setup() {
    const modalConfig = reactive({
      visible: false,
      title: "",
    });

    const formState = reactive({
      custom: null,
      id: null,
      pid: null,
      structureName: null,
    });

    const handleUpdateModal = (type, data) => {
      Object.keys(formState).forEach((key) => {
        formState[key] = null;
      });
      if (type === "echo") {
        formState.custom = data.custom;
        formState.id = data.id;
        formState.pid = data.pid;
        formState.structureName = data.structureName;
      }

      modalConfig.visible = true;

      modalConfig.title = type === "echo" ? "编辑组织架构" : "新增组织架构";
    };

    const handleOk = () => {
      if (!formState.structureName) {
        return Toast("warning", "请输入组织架构名称", 3);
      }
      return new Promise((resolve, reject) => {
        saveStructure(formState)
          .then((res) => {
            let type = res.code === 200 ? "success" : "warning";
            Toast(type, res.message, 3);
            resolve(res);
          })
          .catch((err) => {
            reject(err);
          });
      });
    };

    const handleCancel = () => {};

    return {
      modalConfig,
      formState,
      handleOk,
      handleCancel,
      handleUpdateModal,
    };
  },
});
</script>

<style lang="less" scoped>
</style>
